import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import BackupsComponent from './backups.component';

let BackupsModule = angular
  .module('Backups', [
    uiRouter
  ])
  .component('backups', BackupsComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('backups', {
      url: '/backups',
      data: {
        authRequired: true,
        permsRequired: ['view-backup', 'upload-backup']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'backups',
          bindings: {
            backups: 'backups'
          }
        }
      },
      resolve: {
        backups: (ContentService, ProfilePermissionsService) => {
          return ProfilePermissionsService.hasPermission('view-backup') ? ContentService.getBackupList() : {};
        }
      }
    });
  })
  .name;

export default BackupsModule;



// WEBPACK FOOTER //
// ./src/app/pages/backups/backups.module.js